import React, { useState } from 'react';
import { Box, Skeleton, Slider, Typography, IconButton } from '@mui/material';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import WaveSurferThumbnailViewer from '../common/WaveSurferThumbnailViewer';

interface TimelineSectionProps {
    videoDurationTime: number;
    zoomLevel?: number;
}

const TimelineSection: React.FC<TimelineSectionProps> = ({ videoDurationTime, zoomLevel: initialZoomLevel = 15 }) => {
    const [zoomLevel, setZoomLevel] = useState(50);

    const handleZoomChange = (event: Event, newValue: number | number[]) => {
        setZoomLevel(newValue as number);
    };

    const handleZoomIn = () => {
        setZoomLevel(prev => Math.min(100, prev + 10));
    };

    const handleZoomOut = () => {
        setZoomLevel(prev => Math.max(0, prev - 10));
    };

    if (videoDurationTime === 0) {
        return (
            <Box className="video-info-tab__loading-container">
                <Box className="video-info-tab__loading-header">
                    <Skeleton variant="rectangular" className="skeleton__rectangular-150-10" />
                    <Skeleton variant="rectangular" className="skeleton__rectangular-100-10" />
                </Box>
                <Box className="video-info-tab__loading-bars">
                    {[...Array(80)].map((_, i) => (
                        <Skeleton key={i} variant="rectangular" className="video-info-tab__loading-item" style={{ height: 20 + Math.random() * 20 }} />
                    ))}
                </Box>
                <Skeleton variant="rectangular" className="skeleton__rectangular-full-20" />
            </Box>
        );
    }
    return (
        <div className="video-info-tab__timeline-container">
            <div className="timeline-container">
                <div className="timeline-layout">
                    <div className="col-zoom-slider">
                        <Box className='box-zoom-slider'>
                            <IconButton onClick={handleZoomOut} disabled={zoomLevel <= 0}>
                                <ZoomOutIcon fontSize="small" />
                            </IconButton>
                            <Slider
                                value={zoomLevel}
                                onChange={handleZoomChange}
                                min={0}
                                max={100}
                                step={1}
                                className="editor-tab__zoom-slider"
                            />
                            <IconButton onClick={handleZoomIn} disabled={zoomLevel >= 100}>
                                <ZoomInIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </div>
                </div>
            </div>
            <div className="editor-timeline-wrapper">
                <WaveSurferThumbnailViewer videoDurationTime={videoDurationTime} zoomLevel={zoomLevel} />
            </div>
        </div>
    );
};

export default TimelineSection; 